var _toConsumableArray = require("/codebuild/output/src1787262798/src/tpp-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

/*
 * Copyright 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
var ChangeCase = require('change-case');

var reduce = function reduce(obj, f, accumulator_init) {
  return Object.keys(obj || {}).reduce(function (accumulator, key) {
    var value = obj[key];
    return f(accumulator, value, key, obj);
  }, accumulator_init);
};

var forEach = function forEach(obj, f) {
  Object.keys(obj || {}).forEach(function (key) {
    var value = obj[key];
    f(value, key);
  });
}; // Note: This is a crappy version to a certain extent... don't use with Strings, for example...


var clone = function clone(object) {
  return Object.assign(new object.constructor(), object);
};

var cloneDeep = function cloneDeep(obj) {
  if (obj === null || obj === undefined || typeof obj !== 'object') {
    return obj;
  }

  if (obj instanceof Array) {
    return obj.reduce(function (arr, item, i) {
      arr[i] = cloneDeep(item);
      return arr;
    }, []);
  }

  if (obj instanceof Object) {
    return Object.keys(obj || {}).reduce(function (cpObj, key) {
      cpObj[key] = cloneDeep(obj[key]);
      return cpObj;
    }, {});
  }
};

var isObject = function isObject(value) {
  var type = typeof value;
  return value != null && (type === 'object' || type === 'function');
};

var isString = function isString(obj) {
  return typeof obj === 'string' || obj instanceof String;
};

var isArray = function isArray(obj) {
  return Array.isArray(obj);
};

var isEmpty = function isEmpty(obj) {
  return [Object, Array].includes((obj || {}).constructor) && !Object.entries(obj || {}).length;
};

function isPlainObject(value) {
  if (typeof value !== 'object' || value === null || Object.prototype.toString.call(value) !== '[object Object]') {
    return false;
  }

  if (Object.getPrototypeOf(value) === null) {
    return true;
  }

  var proto = value;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(value) === proto;
}

var filter = function filter(arr, _filter) {
  if (typeof _filter !== 'function') {
    throw "filter is not a function";
  }

  if (typeof arr === 'undefined') {
    return [];
  }

  return arr.filter(_filter);
};

var assign = function assign() {
  var args = Array.prototype.slice.call(arguments);
  args.unshift({});
  return Object.assign.apply(Object, _toConsumableArray(args));
};
/* global Set */


var pull = function pull(arr) {
  for (var _len = arguments.length, removeList = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    removeList[_key - 1] = arguments[_key];
  }

  var removeSet = new Set(removeList);

  for (var i = arr.length - 1; i >= 0; i--) {
    if (removeSet.has(arr[i])) {
      arr.splice(i, 1);
    }
  }
};

var unique = function unique(arr) {
  return _toConsumableArray(new Set(arr));
};

var upperFirst = function upperFirst(str) {
  return str ? str[0].toUpperCase() + str.substr(1) : '';
};

var matchFn = function matchFn(inputObj, testObj) {
  if (isObject(testObj)) {
    return Object.keys(testObj).every(function (key) {
      return matchFn(inputObj[key], testObj[key]);
    });
  } else {
    return inputObj == testObj;
  }
};

var matches = function matches(matchObj) {
  var cloneObj = cloneDeep(matchObj);

  var matchesFn = function matchesFn(inputObj) {
    return matchFn(inputObj, cloneObj);
  };

  return matchesFn;
};

var DEFAULT_OPTIONS = {
  transform: ChangeCase.camelCaseTransformMerge
};

var changeDefaultCaseTransform = function changeDefaultCaseTransform(caseFunction, default_options) {
  return function (caseToChange, options) {
    return caseFunction(caseToChange, Object.assign({}, DEFAULT_OPTIONS, default_options, options));
  };
};

module.exports = {
  each: forEach,
  forEach: forEach,
  forIn: forEach,
  keys: Object.keys,
  clone: clone,
  cloneDeep: cloneDeep,
  extend: Object.assign,
  isString: isString,
  isArray: isArray,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isEmpty: isEmpty,
  filter: filter,
  reduce: reduce,
  assign: assign,
  upperFirst: upperFirst,
  camelCase: changeDefaultCaseTransform(ChangeCase.camelCase),
  snakeCase: ChangeCase.snakeCase,
  kebabCase: ChangeCase.paramCase,
  pull: pull,
  matches: matches,
  unique: unique
};